import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isoCode: 'de',
}

// Export slice
const languageSlice = createSlice({
  name: 'language',
  initialState,
  // Redux Toolkit allows us to write "mutating" logic in reducers. It
  // doesn't actually mutate the state because it uses the immer library,
  // which detects changes to a "draft state" and produces a brand new
  // immutable state based off those changes
  reducers: {
    changeLanguageAction: (draftState, action) => {
      draftState.isoCode = action.payload
    }
  }
})

// Export selector
export const languageSelector = (state) => state.language

export const { changeLanguageAction } = languageSlice.actions

// Export reducer
export default languageSlice.reducer
